<template>
  <Panel ref="PanelRef" :visible="loginPopup" @close="setLoginPopup(false)">
    <div class="login-container">
      <div class="model-left">
        <div class="title">登录</div>
        <div class="desc">
          <span>请使用</span>
          <el-popover placement="top" trigger="hover" popper-class="download-popover">
            <img class="qrcode" src="@/assets/img/qrcode/download.png" alt="易隆创" />
            <span class="app-name" slot="reference">易隆创app</span>
          </el-popover>
          <span>/微信<br>扫描二维码登录</span>
        </div>
        <div class="qr-code-box">
          <CodeLogin @login-success="handleLoginSuccess" />
        </div>
        <div class="remark">登录视为您已阅读并同意易隆创服务条款和隐私政策</div>
      </div>
      <div class="model-right">
        <el-tabs class="el-tabs" v-model="activeName">
          <el-tab-pane label="手机号登录/注册" name="phone-login">
            <PhoneLogin ref="phoneLogin" @login-success="handleLoginSuccess" @popup="popupSlidingCaptcha('phoneLogin')" />
          </el-tab-pane>
          <el-tab-pane label="账户登录" name="password-login">
            <PasswordLogin ref="passwordLogin" @login-success="handleLoginSuccess" @popup="popupSlidingCaptcha('passwordLogin')" />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- 滑块验证 -->
    <div ref="slidingCaptcha"></div>
  </Panel>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Panel from '@/components/Popup/Panel.vue';
import CodeLogin from './codeLogin.vue';
import PasswordLogin from './passwordLogin.vue';
import PhoneLogin from './phoneLogin.vue';
import slidingCaptcha from "./sliding-captcha";
import { getCurrentUser } from "@/api/home/home.js";
import UserApi from "@/api/system/userApi.js";

export default {
  name: "login_popup",
  components: { Panel, CodeLogin, PasswordLogin, PhoneLogin },
  data() {
    return {
      activeName: 'phone-login',
    };
  },
  computed: {
    ...mapState({
      loginPopup: state => state.comp.loginPopup,
      loginCallback: state => state.comp.loginCallback,
    })
  },
  methods: {
    ...mapActions(['setLoginPopup', 'setLoginCallback']),
    async handleLoginSuccess(token) {
      await this.$store.dispatch("setToken", token);
      // 获取当前用户信息，存入vuex
      getCurrentUser().then((user) => {
        this.$store.dispatch("setCurrentUser", user?.model || null);
        // 登录成功后，执行回调函数
        if (typeof this.loginCallback === 'function') {
          this.loginCallback(user?.model || {});
          this.setLoginCallback(null);
        }
        // 设置认证状态
        this.setAuthStatus(user?.model?.companyId).then(status => {
          this.$store.dispatch("setAuthStatus", status);
          // 判断是否需要前往认证
          /* if (['UNCOMPLETED', 'BACK'].includes(status)) {
            this.$confirm('信息未完善，是否前往完善信息？', '提示').then(() => {
              this.$router.push('/personalInfo');
            });
          } */
        });
      });
      // 登录成功后，关闭弹窗
      this.setLoginPopup(false);
      this.$message.success('登录成功！');
    },
    /**
     * @description 弹出滑块验证
     */
    popupSlidingCaptcha(ref) {
      slidingCaptcha.init({
        el: this.$refs["slidingCaptcha"],
        type: "popup", // popup：弹出式，trigger：触发式，embed：内嵌式
        onSuccess: (key) => {
          this.$refs[ref].getVerificationCode(key);
        },
        onFail: () => {},
      });
    },
    // 设置认证状态
    async setAuthStatus(companyId) {
      if (!companyId) return;
      if (companyId !== '999999999999') return 'COMPLETED';
      else {
        const res = await UserApi.authentication();
        if (res?.code === '00000') {
          let { perfectDegree } = res.rows?.find(v => v.type == 'companyAuthentication');
          return perfectDegree;
        }
      }
    },
  },
};
</script>

<style lang="less">
.el-popover.download-popover {
  min-width: auto;
  padding: 5px;
  font-size: 0;
  .qrcode {
    width: 140px;
    height: 140px;
  }
}

.login-container {
  .el-form-item.is-error,
  .el-form-item {
    // margin-bottom: 20px;
    /* 输入框样式 */
    .el-input {
      .el-input__inner {
          height: 46px;
          background-color: transparent;
          color: #262626;
          padding-left: 18px;
          line-height: 48px;
          border: 1px solid #dde2e9;
      }

      input {
          /* WebKit, Blink, Edge (Chrome, Safari, Edge) */
          &::placeholder {
              color: #979ea5;
              opacity: 1;
              /* 有些浏览器默认透明度 < 1 */
          }

          /* Firefox */
          &::-moz-placeholder {
              color: #979ea5;
              opacity: 1;
          }

          &:-webkit-autofill {
              -webkit-transition-delay: 99999s;
              -webkit-transition: color 99999s ease-out,
                  background-color 99999s ease-out;
          }
      }

      .el-input__suffix {
          .el-input__count-inner {
              background-color: transparent;
          }
      }
    }
  }
}
</style>

<style scoped lang="less">
@import "./sliding-captcha/main.css";
.login-container {
  width: 800px;
  height: 458px;
  background-color: #fff;
  border-radius: 6px;
  padding: 60px 64px;
  display: flex;
  .model-left {
    // width: 200px;
    height: 100%;
    padding-right: 60px;
    position: relative;
    &::after {
      content: '';
      width: 1px;
      height: calc(100% - 20px);
      background-color: #eee;
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
    .title {
      font-family: @font-medium;
      font-size: 34px;
    }
    .desc {
      margin-top: 12px;
      font-size: 14px;
      line-height: 22px;
      .app-name {
        color: @primary-color;
        cursor: pointer;
        user-select: none;
      }
    }
    .qr-code-box {
      margin-top: 10px;
      border: 1px solid #eee;
      border-radius: 2px;
      font-size: 0;
    }
    .remark {
      width: 160px;
      margin-top: 8px;
      font-size: 12px;
      color: #666;
    }
  }
  .model-right {
    flex: 1;
    height: 100%;
    padding-left: 60px;
    .el-tabs {
      :deep(.el-tabs__header) {
        .el-tabs__item {
          font-family: @font-medium;
          font-size: 16px;
          &:hover,
          &.is-active {
            color: @primary-color;
          }
        }
        .el-tabs__active-bar {
          background-color: @primary-color;
          border-radius: 1px;
        }
        .el-tabs__nav-wrap::after {
          display: none;
        }
      }
    }
  }
}
</style>
